import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';
import { useTransactions } from 'lib/hooks/queries/billing/useTransactions';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import ReceiptModal from 'components/shared/Receipt/ReceiptModal';
import { getColDefs } from 'components/shared/Transactions/components/lib/configs';
import { permissions as userPermissions } from 'components/state';

import TransactionResponseModal from './TransactionResponseModal';
import { DEFAULT_FILTERS } from './configs';

const Transactions = ({ patient_id }) => {
  const { id } = useParams();
  const { transactionId } = useParams();
  const navigate = useNavigate();

  const patientId = patient_id || id;
  const practice = useRecoilValue(currentPractice);
  const practiceTimezone = practice.timezone;
  const permissions = useRecoilValue(userPermissions);

  const cols = getColDefs({ isFromPractice: true, timezone: practiceTimezone, permissions });

  return (
    <>
      <AgTablePage
        ModalComponent={pm(permissions, 'is_admin') ? TransactionResponseModal : undefined}
        name="transactions"
        patientId={patientId}
        defaultColDef={cols}
        useData={useTransactions}
        defaultFilters={DEFAULT_FILTERS}
        defaultColumns={cols}
        rowStyle={{ cursor: 'pointer' }}
        queryParams={{ patientId }}
        noTitle
        noNewButton
      />

      {transactionId && (
        <ReceiptModal isOpen transactionId={transactionId} onClose={() => navigate('')} />
      )}
    </>
  );
};

export default Transactions;
